import {
  Input as CInput,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  type FormLabelProps,
  InputGroup,
} from "@chakra-ui/react";
import { type FC, forwardRef } from "react";
import { NumericFormat, type NumberFormatValues } from "react-number-format";

export interface MoneyInputProps {
  name: string;
  value?: number | string | null;
  onChange?: (value: number | undefined) => void;
  onBlur?: () => void;
  label: string;
  helperText?: string;
  error?: string;
  labelProps?: FormLabelProps;
  isDisabled?: boolean;
  isRequired?: boolean;
  isInvalid?: boolean;
  placeholder?: string;
  decimalScale?: number;
  allowNegative?: boolean;
  prefix?: string;
  mb?: string | number;
}

export const MoneyInput: FC<MoneyInputProps> = forwardRef<HTMLInputElement, MoneyInputProps>(
  (
    {
      name,
      value,
      onChange,
      onBlur,
      label,
      helperText,
      isDisabled = false,
      isRequired = false,
      isInvalid = false,
      error,
      labelProps = {},
      placeholder,
      decimalScale = 2,
      allowNegative = false,
      prefix = "$",
      mb = "2",
    },
    ref,
  ) => {
    return (
      <FormControl isDisabled={isDisabled} isRequired={isRequired} isInvalid={isInvalid} mt="1" mb={mb}>
        <FormLabel mt="0" p="0" fontSize="md" {...labelProps}>
          {label}
        </FormLabel>
        <InputGroup>
          <NumericFormat
            getInputRef={ref}
            customInput={CInput}
            name={name}
            value={value ?? ""}
            thousandSeparator
            decimalScale={decimalScale}
            allowNegative={allowNegative}
            prefix={prefix}
            placeholder={placeholder}
            disabled={isDisabled}
            onValueChange={(v: NumberFormatValues) => onChange?.(v.floatValue)}
            onBlur={onBlur}
            bg="white"
            borderWidth="1px"
            borderRadius="5px"
            pt="10px"
            pb="10px"
            m="0"
            type="text"
            inputMode="decimal"
          />
        </InputGroup>
        <FormErrorMessage>{error}</FormErrorMessage>
        {helperText && !error && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>
    );
  },
);

MoneyInput.displayName = "MoneyInput";
